import { getApiBaseUrl } from '../config/apiBase';

const documentUploadApiUrl =
  process.env.REACT_APP_DATAROOM_UPLOAD_API_URL || `${getApiBaseUrl()}/dataroom-proxy`;

export default documentUploadApiUrl;
